import { securedAxiosInstance } from "../axios";

class ContractMigrationConsentsService {
  getConsents() {
    return securedAxiosInstance.get("/contract_migration_consents");
  }

  updateConsent(id, status) {
    return securedAxiosInstance.patch(`/contract_migration_consents/${id}`, { status });
  }
}

export default new ContractMigrationConsentsService();
